const style = (theme) => {
  const output = {
    root: {
      position: 'fixed',
      top: 0,
      right: 0,
      width: '100vw',
      height: '100vh',
      fallback: {
        height: 'calc(var(--vh) * 100)',
      },
      background: theme.colors[0],
      zIndex: theme.zindex.mainNav,
      paddingTop: (props) => props.headerHeight,
      paddingBottom: 50,
      overflowY: 'auto',
      overflowX: 'hidden',
      '& li.special': {
        margin: '15px 0',
        '& a': {
          padding: '3px 30px 8px 30px',
          borderRadius: 20,
          background: theme.colors[8],
          color: theme.colors[1],
          transition: 'all .3s ease-in-out',
          '&:hover': {
            background: theme.colors[1],
            color: theme.colors[8],
          },
          '&:before': {
            content: 'none',
          },
        },
      },
      '& a': {
        position: 'relative',
        color: theme.colors[1],
        '&:before': {
          content: '""',
          position: 'absolute',
          zIndex: -1,
          bottom: 0,
          left: 0,
          width: '100%',
          height: 1,
          background: theme.colors[1],
          transformOrigin: '100% 0',
          transform: 'scaleX(0)',
          transition: `transform .5s ${theme.easings['power4.out']}`,
          willChange: 'transform',
        },
        '&:hover': {
          '&:before': {
            transformOrigin: '0% 0',
            transform: 'scaleX(1)',
          },
        },
      },
    },
    container: {
      extend: theme.wrapper,
      margin: '0 auto',
      height: '100%',
    },
    wrapper: {
      height: '100%',
      position: 'relative',
      margin: 0,
      color: theme.colors[0],
      display: 'flex',
      flexDirection: 'column',
    },
    wrapperMain: {
      position: 'absolute',
      top: 0,
      width: '100%',
      height: 'calc(100% - 45px)',
      overflowY: 'auto',
      scrollBehavior: 'smooth',
    },
    wrapperMainNav: {
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      flex: 1,
      letterSpacing: '2px',
      width: '100%',
      height: '100%',
      display: 'table',
      '& li': {
        textTransform: 'uppercase',
        textAlign: 'center',
      },
    },
    wrapperTableNav: {
      display: 'table-cell',
      position: 'relative',
      verticalAlign: 'middle',
    },
    wrapperFooterNav: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 14,
      lineHeight: 1,
      marginTop: 50,
      letterSpacing: 0.2,
    },
    nav: {},
    mainNav: {
      fontSize: 'calc(20px + 2vw)',
      textTransform: 'uppercase',
      '& li': {
        textAlign: 'center',
      },
      '& a': {
        fontFamily: theme.fonts[1],
        fontWeight: 700,
      },
    },
    extraNav: {
      marginTop: 60,
      fontSize: 24,
    },
    visible: {
      opacity: 1,
    },
    linkedinBtn: {
      position: 'relative',
      '&::before': {
        content: 'none !important',
      },
      '& svg': {
        width: 20,
        height: 20,
        fill: theme.colors[1],
      },
    },
  }

  output['@media (max-height: 680px)'] = {
    mainNav: {
      fontSize: 'calc(20px + 3vh)',
      '& li': {
        lineHeight: 1.2,
      },
    },
    extraNav: {
      marginTop: '4vh',
      fontSize: 18,
      '& li': {
        lineHeight: 1.2,
      },
    },
  }

  output[theme.mediaInverse.sm] = {
    mainNav: {
      fontSize: 30,
    },
    extraNav: {
      fontSize: 18,
    },
  }

  return output
}

export default style
